/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable no-unreachable */
/* eslint-disable no-await-in-loop */
/* eslint-disable object-curly-newline */
import axios from '../../libs/axios'

const mjml = `<mjml>
<mj-body>
  <mj-raw>
    <!-- Company Header -->
  </mj-raw>
  <mj-raw>
    <!-- Image Header -->
  </mj-raw>
  <mj-section padding-top="0px"></mj-section>
  <mj-hero
    mode="fluid-height"
    background-width="600px"
    background-height="210px"
    background-position="bottom"
    background-url=
        "https://saturiwa.b-cdn.net/saturiwaheader.jpg?aspect_ratio=20:9"
    background-color="#2a3448">
  </mj-hero>
  <mj-raw>
    <!-- Intro text -->
  </mj-raw>
  <mj-wrapper background-color="#fafafa" padding-top="0">
    
    <!-- Big image display -->
    <mj-section padding-bottom="0px">
      <mj-column width="630px">
        <mj-text font-style="bold" font-size="30px" font-family="Helvetica Neue" color="#626262" padding-bottom="0">
          <b>Thor's Hammer</b>
          <span style="font-size: 17px; margin-left: 5px;">$9.85 per lb</span>
       </mj-text>
        <mj-text font-style="italic" padding-top="5px" color="#626262">This week's featured item</mj-text>
      </mj-column>
    </mj-section>
    <mj-section padding-top="10px" padding="20px">
      
      <mj-column width="50%" padding="5px" padding-bottom="0">
        <mj-table padding="0px">
          <tr>
            <td>
              <a target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/">
                  <img src="https://saturiwa.b-cdn.net/thorsHammer1.jpg?quality=50&width=720" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
              </a>
            </td>
          </tr>
        </mj-table>
        <mj-table padding-top="10px" container-background-color="#6c6c6c" padding-left="15px">
          <tr>
            <td width="30">
              <img src="https://saturiwa.b-cdn.net/linkIconWhite.png" width="15"></img>
            </td>
            <td style="line-height: 15px;">
              <a href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="text-decoration: none;color: white !important; font-size:13px;" target="_blank" style="display:block;">Check out this recipe!</a>
            </td>
          </tr>
        </mj-table>
      </mj-column>
      <mj-column width="50%" padding="5px" padding-top="5px" padding-bottom="0">
       <mj-table padding="0px">
          <tr>
            <td>
              <a target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/">
                  <img src="https://saturiwa.b-cdn.net/thorsHammer2.jpeg?quality=50&width=720" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
              </a>
            </td>
          </tr>
        </mj-table>
        <mj-table padding-top="10px" container-background-color="#6c6c6c" padding-left="15px">
          <tr>
            <td width="30">
              <img src="https://saturiwa.b-cdn.net/linkIconWhite.png" width="15"></img>
            </td>
            <td style="line-height: 15px;">
              <a href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="text-decoration: none;color: white !important; font-size:13px;" target="_blank">View the farm where the beef was grown</a>
            </td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    <mj-section padding-top="0px">
      <mj-column width="630px" padding="0">
        <mj-text>
          Thanks to Chef Mike Riska and the crew at Valley Smoke for smoking this up and taking some pictures! Has a really nice beef flavor.
          <br/><br/>
          Some take aways from testing it out are - Maybe brine first, since its such a thick cut of meat and or braise in tasty braising liquid.
        </mj-text>
      </mj-column>
    </mj-section>
    
    
    <mj-section padding-top="10px">
      <mj-column width="600px">
        <mj-text font-style="bold" font-size="30px" font-family="Helvetica Neue" color="#626262"><b>Latest Updates</b></mj-text>
        <mj-text color="#525252">We have started a fresh Duck program. Please let us know if you want to get on the pre-order list. Couple case might be available this week. Crescent Farms Ducks are allegedly perfect Ducks. The flavor, meat to fat ratio and size. Please let us know if you want</mj-text>
        <!-- <mj-button background-color="#F45E43" href="#">Learn more</mj-button> -->
     </mj-column>
      <mj-column width="50%">
        <mj-table padding-top="10px">
          <tr>
            <td width="40">
              <img src="https://saturiwa.b-cdn.net/icons8-checkmark-96.png" width="30"></img>
            </td>
            <td style="line-height: 15px;">
              <b style="color: #626262; font-size: 16px;">Fresh Uni</b>
              <br/>
              <span style="color: #626262; font-size: 12px;">$10.22 per pound</span>
            </td>
          </tr>
        </mj-table>
        <mj-table>
          <tr>
            <td width="40">
              <img src="https://saturiwa.b-cdn.net/icons8-checkmark-96.png" width="30"></img>
            </td>
            <td style="line-height: 15px;">
              <b style="color: #626262; font-size: 16px;">Cherokee Heirlooms</b>
              <br/>
              <span style="color: #626262; font-size: 12px;">Now in and delicious!</span>
            </td>
          </tr>
        </mj-table>
        <mj-table>
          <tr>
            <td width="40">
              <img src="https://saturiwa.b-cdn.net/icons8-checkmark-96.png" width="30"></img>
            </td>
            <td style="line-height: 15px;">
              <b style="color: #626262; font-size: 16px;">Rambuhtan</b>
              <br/>
              <span style="color: #626262; font-size: 12px;">$8 per lb</span>
            </td>
          </tr>
        </mj-table>
        <mj-table>
          <tr>
            <td width="40">
              <img src="https://saturiwa.b-cdn.net/icons8-checkmark-96.png" width="30"></img>
            </td>
            <td style="line-height: 15px;">
              <b style="color: #626262; font-size: 16px;">Peas and Watermelons</b>
              <br/>
              <span style="color: #626262; font-size: 12px;">Thank the hot Florida weather!</span>
            </td>
          </tr>
        </mj-table>
      </mj-column>
      <mj-column width="50%">
        <mj-table>
          <tr>
            <td width="40">
              <img src="https://saturiwa.b-cdn.net/cancelGrey.png" width="30"></img>
            </td>
            <td style="line-height: 15px;">
              <b style="color: #626262; font-size: 16px;">Caviar</b>
              <br/>
              <span style="color: #626262; font-size: 12px;">Still no caviar :(</span>
            </td>
          </tr>
        </mj-table>
      </mj-column>
      <mj-column width="600px">
        <mj-text color="#626262" padding-bottom="20px">Let me know if you want anything from his Farm!</mj-text>
      </mj-column>
    </mj-section>
    
    <!-- CALL TO ACTION -->
    <mj-section padding="0">
      <mj-column width="50%">
        <mj-table padding-top="10px" container-background-color="#f47020">
          <tr>
            <td width="30">
              <img src="https://saturiwa.b-cdn.net/shoppingCart.png" width="20" style="margin-left:7px;"></img>
            </td>
            <td style="line-height: 15px; padding-left: 10px;">
              <span style="color: white;">Email your order to:</span><br/>
              <a href="mailto:shebobah@gmail.com" style="text-decoration: none;color: white !important; font-size:13px;" target="_blank"><b>shebobah@gmail.com</b></a>
            </td>
          </tr>
        </mj-table>
      </mj-column>
      <mj-column width="50%">
        <mj-table padding-top="10px" container-background-color="#f47020">
          <tr>
            <td width="40">
            </td>
            <td style="line-height: 15px;">
              <span style="color: white;">or text</span><br/>
              <a href="tel:904-549-9245" style="text-decoration: none;color: white !important; font-size:13px;"><b>904-549-9245</b></a>
            </td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    <!-- END CALL TO ACTION -->
    
    <mj-section padding="0px" padding-top="10px">
      <mj-column width="600px" padding="0">
        <mj-text padding="10px" container-background-color="#eee" color="#626262" padding-left="65px">
          <div style="padding-bottom: 5px; color: #f47020; font-size: 16px;"><b>We deliver!</b></div>
          <span style=""><b>Monday - Saturday</b><span style="margin-left: 5px;">(Jax, Jax Beaches & surrounding areas)</span></span><br/>
          <span style=""><b>Wednesday & Friday</b><span style="margin-left: 5px;">(Amelia Island & Fernandina)</span></span><br/>
          <span style=""><b>Thurs</b><span style="margin-left: 5px;">(St. Augustine & St. Johns)</span></span>
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- FULL PRODUCT LIST BUTTONS -->
    <mj-section padding-bottom="0px">
      <mj-column width="600px">
        <mj-text font-style="bold" font-size="30px" font-family="Helvetica Neue" color="#626262"><b>Full Product Lists</b></mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section padding-bottom="25px" padding-top="0" padding-left="20px" padding-right="20px">
      <mj-column padding="0px" width="33%">
        <mj-button font-family="Helvetica" background-color="#6c6c6c" color="white" width="100%" padding="4px" href="https://docs.google.com/spreadsheets/d/14ox-15eZ1XW8VI-VGeWhyut1lYiA10v-/edit#gid=204656775" target="_blank">
          Meats
        </mj-button>
      </mj-column>
      <mj-column padding="0px" width="33%">
        <mj-button font-family="Helvetica" background-color="#6c6c6c" color="white" width="100%" padding="4px">
          Caviar & Eggs
        </mj-button>
      </mj-column>
      <mj-column padding="0px" width="33%">
        <mj-button font-family="Helvetica" background-color="#6c6c6c" color="white" width="100%" padding="4px">
          Mushrooms
        </mj-button>
      </mj-column>
       <mj-column padding="0px" width="33%">
        <mj-button font-family="Helvetica" background-color="#6c6c6c" color="white" width="100%" padding="4px">
          Rice & Grains
        </mj-button>
      </mj-column>
      <mj-column padding="0px" width="33%">
        <mj-button font-family="Helvetica" background-color="#6c6c6c" color="white" width="100%" padding="4px">
          Fresh Herbs
        </mj-button>
      </mj-column>
      <mj-column padding="0px" width="33%">
        <mj-button font-family="Helvetica" background-color="#6c6c6c" color="white" width="100%" padding="4px">
          Garnishes
        </mj-button>
      </mj-column>
      <mj-column padding="0px" width="33%">
        <mj-button font-family="Helvetica" background-color="#6c6c6c" color="white" width="100%" padding="4px">
          Spice Blends
        </mj-button>
      </mj-column>
    </mj-section>
    <!-- END FULL PRODUCT LIST BUTTONS -->
    
    
    <mj-section padding="15px" padding-bottom="5px" padding-top="5px">
      <mj-column width="34%" padding="10px">
         <mj-table padding="0px">
          <tr>
            <td>
              <img src="https://saturiwa.b-cdn.net/greymorels2.jpg?quality=50&width=720&rotate=90" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
            </td>
          </tr>
        </mj-table>
      </mj-column>
      <mj-column width="66%" padding="10px">
        <mj-text font-size="24px" color="#626262" padding-left="0px" padding-top="0px">
          <b>Grey Morels</b>
        </mj-text>
        <mj-text font-size="20px" color="#626262" padding-left="0px" padding-top="4px">
          <b>$29.50 / lb</b>
        </mj-text>
        <mj-text  color="#626262" padding-left="0px">
          Morels are great for cooking!
        </mj-text>
      </mj-column>
    </mj-section>
    
    <mj-section padding="15px" padding-top="5px" padding-bottom="5px">
      <mj-column width="33%" padding="10px">
        <mj-table padding="0px">
          <tr>
            <td>
              <a target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/">
                  <img src="https://saturiwa.b-cdn.net/cherokeetomatoes2.jpg?quality=50&width=720&rotate=90" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
              </a>
            </td>
          </tr>
        </mj-table>
        <!-- <mj-image src="https://saturiwa.b-cdn.net/cherokeetomatoes2.jpg?quality=50&width=720&rotate=90" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/"></mj-image> -->
        <mj-table container-background-color="#6c6c6c">
          <tr>
            <td width="25">
              <img src="https://saturiwa.b-cdn.net/linkIconWhite.png" width="15"></img>
            </td>
            <td style="line-height: 15px;">
              <a href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="text-decoration: none;color: white !important; font-size:13px;" target="_blank">Learn more!</a>
            </td>
          </tr>
        </mj-table>
      </mj-column>
      <mj-column width="66%" padding="10px">
        <mj-text font-size="24px" color="#626262" padding-left="0px" padding-top="0px">
          <b>Cherokee Heirloom Tomatoes</b>
        </mj-text>
        <mj-text font-size="20px" color="#626262" padding-left="0px" padding-top="4px">
          <b>$46 / box</b>
        </mj-text>
        <mj-text  color="#626262" padding-left="0px">
          "One day in 1990, a packet of tomato seeds arrived in LeHoullier's mail with a handwritten note. The sender was John Green of Sevierville, Tenn., who wrote that the seeds came from very good tomatoes he'd gotten from a woman who received them from her neighbors. The neighbors said that the varietal had been in their family for 100 years, and that the seeds were originally received from Cherokee Indians."
        </mj-text>
      </mj-column>
    </mj-section>
    
    <!-- 3 COLUMN DISPlAY -->
    <mj-section padding="15px" padding-top="5px" padding-bottom="0px">
      <mj-column width="33%" padding="10px">
        <mj-table padding="0px">
          <tr>
            <td>
              <img src="https://saturiwa.b-cdn.net/rambuhtan.jpg?quality=50&width=720&aspect_ratio=1:1" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
            </td>
          </tr>
        </mj-table>
        <mj-text padding-left="0" color="#626262" line-height="18px">
          <b style="font-size: 16px;">Rambuhtan</b><br/>
          <b>$8 / lb</b><br/>
        </mj-text>
      </mj-column>
      <mj-column width="33%" padding="10px">
        <mj-table padding="0px">
          <tr>
            <td>
              <img src="https://saturiwa.b-cdn.net/fingerLimes.JPG?quality=50&width=720&aspect_ratio=1:1" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
            </td>
          </tr>
        </mj-table>
        <mj-text padding-left="0" color="#626262" line-height="18px">
          <b style="font-size: 16px;">Fresh Finger Limes</b><br/>
          <b>$42 / case</b><br/>
        </mj-text>
      </mj-column>
      <mj-column width="33%" padding="10px">
        <mj-table padding="0px">
          <tr>
            <td>
              <img src="https://saturiwa.b-cdn.net/burratina.JPG?quality=50&width=720&aspect_ratio=1:1" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
            </td>
          </tr>
        </mj-table>
        <mj-text padding-left="0" color="#626262" line-height="18px">
          <b style="font-size: 16px;">Burratina</b><br/>
          <b>$42 / case</b><br/>
          2ct cups - 6/case(12 ea)<br/>
        </mj-text>
      </mj-column>
    </mj-section>
    <!-- END 3 COLUMN DISPLAY -->
    
     <!-- 3 COLUMN DISPlAY -->
    <mj-section padding="15px" padding-top="0px">
      <mj-column width="33%" padding="10px">
        <mj-table padding="0px">
          <tr>
            <td>
              <img src="https://saturiwa.b-cdn.net/rambuhtan.jpg?quality=50&width=720&aspect_ratio=1:1" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
            </td>
          </tr>
        </mj-table>
        <mj-text padding-left="0" color="#626262" line-height="18px">
          <b style="font-size: 16px;">Rambuhtan</b><br/>
          <b>$8 / lb</b><br/>
        </mj-text>
      </mj-column>
      <mj-column width="33%" padding="10px">
        <mj-table padding="0px">
          <tr>
            <td>
              <img src="https://saturiwa.b-cdn.net/fingerLimes.JPG?quality=50&width=720&aspect_ratio=1:1" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
            </td>
          </tr>
        </mj-table>
        <mj-text padding-left="0" color="#626262" line-height="18px">
          <b style="font-size: 16px;">Fresh Finger Limes</b><br/>
          <b>$42 / case</b><br/>
        </mj-text>
      </mj-column>
      <mj-column width="33%" padding="10px">
        <mj-table padding="0px">
          <tr>
            <td>
              <img src="https://saturiwa.b-cdn.net/burratina.JPG?quality=50&width=720&aspect_ratio=1:1" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
            </td>
          </tr>
        </mj-table>
        <mj-text padding-left="0" color="#626262" line-height="18px">
          <b style="font-size: 16px;">Burratina</b><br/>
          <b>$42 / case</b><br/>
          2ct cups - 6/case(12 ea)<br/>
        </mj-text>
      </mj-column>
    </mj-section>
    <!-- END 3 COLUMN DISPLAY -->
    
    <!-- CALL TO ACTION -->
    <mj-section padding="0">
      <mj-column width="50%">
        <mj-table padding-top="10px" container-background-color="#f47020">
          <tr>
            <td width="30">
              <img src="https://saturiwa.b-cdn.net/shoppingCart.png" width="20" style="margin-left:7px;"></img>
            </td>
            <td style="line-height: 15px; padding-left: 10px;">
              <span style="color: white;">Email your order to:</span><br/>
              <a href="mailto:shebobah@gmail.com" style="text-decoration: none;color: white !important; font-size:13px;" target="_blank"><b>shebobah@gmail.com</b></a>
            </td>
          </tr>
        </mj-table>
      </mj-column>
      <mj-column width="50%">
        <mj-table padding-top="10px" container-background-color="#f47020">
          <tr>
            <td width="40">
            </td>
            <td style="line-height: 15px;">
              <span style="color: white;">or text</span><br/>
              <a href="tel:904-549-9245" style="text-decoration: none;color: white !important; font-size:13px;"><b>904-549-9245</b></a>
            </td>
          </tr>
        </mj-table>
      </mj-column>
    </mj-section>
    <!-- END CALL TO ACTION -->
    
    <mj-section padding="15px" padding-top="5px" padding-bottom="5px">
      <mj-column width="50%" padding="10px">
        <mj-table padding="0px">
          <tr>
            <td>
              <a target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/">
                  <img src="https://saturiwa.b-cdn.net/mashimawagyu.JPG?quality=50&width=720&aspect_ratio=5:6" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
              </a>
            </td>
          </tr>
        </mj-table>
        <!-- <mj-image src="https://saturiwa.b-cdn.net/cherokeetomatoes2.jpg?quality=50&width=720&rotate=90" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/"></mj-image> -->
        <mj-table container-background-color="#6c6c6c">
          <tr>
            <td width="25">
              <img src="https://saturiwa.b-cdn.net/linkIconWhite.png" width="15"></img>
            </td>
            <td style="line-height: 15px;">
              <a href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="text-decoration: none;color: white !important; font-size:13px;" target="_blank">Learn more!</a>
            </td>
          </tr>
        </mj-table>
        <mj-text font-size="24px" color="#626262" padding-left="0px" padding-top="10px" padding-bottom="4px">
          <b>Mashima Reserve Wagyu Bavette</b>
        </mj-text>
        <mj-text font-size="18px" color="#626262" padding-left="0px" padding-top="4px">
          <b>$46 / box</b>
        </mj-text>
        <mj-text color="#626262" padding-left="0px" padding-right="0px" padding-top="0px">
          With foraged mushroom bordelaise, Fresh Black Truffle Arancini and Farm 509 Parm crisp. By Chef Taylor Pickett
        </mj-text>
      </mj-column>
      <mj-column width="50%" padding="10px">
        <mj-table padding="0px">
          <tr>
            <td>
              <a target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/">
                  <img src="https://saturiwa.b-cdn.net/Uni.jpg?quality=50&width=720&aspect_ratio=5:6" width="100%" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="display:block;"/>
              </a>
            </td>
          </tr>
        </mj-table>
        <!-- <mj-image src="https://saturiwa.b-cdn.net/cherokeetomatoes2.jpg?quality=50&width=720&rotate=90" padding="0" target="_blank" href="https://cookwhatyoulove.com/smoked-thors-hammer/"></mj-image> -->
        <mj-table container-background-color="#6c6c6c">
          <tr>
            <td width="25">
              <img src="https://saturiwa.b-cdn.net/linkIconWhite.png" width="15"></img>
            </td>
            <td style="line-height: 15px;">
              <a href="https://cookwhatyoulove.com/smoked-thors-hammer/" style="text-decoration: none;color: white !important; font-size:13px;" target="_blank">Learn more!</a>
            </td>
          </tr>
        </mj-table>
        <mj-text font-size="24px" color="#626262" padding-left="0px" padding-top="10px" padding-bottom="4px">
          <b>Fresh Uni (not frozen)</b>
        </mj-text>
        <mj-text font-size="18px" color="#626262" padding-left="0px" padding-top="4px">
          <b>$90 / case</b>
        </mj-text>
      </mj-column>
    </mj-section>
    
    
  </mj-wrapper>
  <mj-raw>
    <!-- Side image -->
  </mj-raw>
  <mj-section background-color="white">
    
  </mj-section>
  
</mj-body>
</mjml>`

const actions = {
    ActionGetFeaturedInventory({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('shopify/inventory-featured')
          .then(response => {
              console.log('Response', response.data.data)
              commit('SetFeaturedInventory', response.data.data)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    ActionSubmitContactForm({ commit, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        axios.post('mail/sendmail', payload)
          .then(response => {
              console.log('Response', response.data)
              resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
    ActionSetShowedConstruction({ commit }) {
      commit('SetShowedConstruction', true)
    },
    ActionSetMailPActive({ commit }, payload) {
      commit('SetMailPActive', payload)
    },
    ActionAddEmailItem({ commit }, itemType) {
      commit('AddEmailItem', itemType)
    },
    ActionGetMJMLHTML({ commit, dispatch }) {
      return new Promise((resolve, reject) => {
        axios.post('https://api.mjml.io/v1/render', {
          mjml: mjml,
        }, {
          headers: {
          'Authorization': 'Basic ZGEyYWI2NzctYjliMC00YWFmLWJlODQtZDg0YmRiMjgyMjNlOmY0ODNjZTY0LTM1MTUtNDhkYy1iNWY3LWU4MDIwY2NlMTc3ZA==', 
          }
        })
          .then(response => {
              console.log('Response', response.data)
              commit('SetMJMLHTML', response.data.html)
              resolve(response.data)
          })
          .catch(error => {
            console.log(error)
            reject(error)
          })
      })
    },
}

export default actions
